import * as React from 'react'
import { useFormikContext } from 'formik'
import { CustomFieldAutocomplete } from './atoms'
import type {
  EditableCustomFieldProps,
  ICustomFieldValueFormModel,
} from './typings'
import { useHideOptional } from './useHideOptional'

export function EditableCustomSingleSelect(props: EditableCustomFieldProps) {
  const {
    field: { id },
  } = props

  const {
    values: {
      customFields: { single },
    },
  } = useFormikContext<ICustomFieldValueFormModel>()

  const selectedOptions = single[id]?.value ?? null

  const showField = useHideOptional(props)

  if (!showField) return null

  return (
    <CustomFieldAutocomplete
      {...props}
      type="single"
      selectedOptions={selectedOptions}
    />
  )
}
